import React from 'react';
import NumericLabel from 'react-pretty-numbers';

const PrettyNumbers = (props) => {
  const params = {
    justification: 'L',
    locales: 'en-AU',
    currency: props.currency,
    currencyIndicator: 'USD',
    percentage: props.percentage,
    precision: props.precision,
    commafy: false,
    shortFormat: true,
    title: true,
  };
  return <NumericLabel params={params}>{props.children}</NumericLabel>;
};

export default PrettyNumbers;
